import RedTimerIcon from './ic_timer.svg';
import Metapo24X24Icon from './metapo_24x24.svg';
import Metapo48X48Icon from './metapo_48x48.svg';
import Metapo88X88Icon from './metapo_88x88.svg';

export { Metapo24X24Icon, Metapo48X48Icon, Metapo88X88Icon, RedTimerIcon };
